module.exports = __webpack_public_path__ + "img/85.86b8243a.png";